var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { CUSTOMER_SUPPORT_REQUEST, customerSupportIssueFailure, customerSupportIssueSuccess, } from "../../actions";
import API from "../../../utils/API";
export const customerSupportIssueDetails = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const data = action.payload;
        try {
            API.post("/notification/support", data)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* customerIssuesDataWorker(action) {
    try {
        const data = yield call(customerSupportIssueDetails, action);
        yield put(customerSupportIssueSuccess(data));
    }
    catch (error) {
        yield put(customerSupportIssueFailure(error.toString()));
    }
}
export function* watchCustomerIssueData() {
    yield takeLatest(CUSTOMER_SUPPORT_REQUEST, customerIssuesDataWorker);
}
